import type { VanityLink } from "./types.js";

export const UTM_TERM_PARAM_DEFAULT = "utm_term";

/** Query param names we'll accept as a beacon override. */
export function isValidParamName(name: string): boolean {
  return /^[a-zA-Z0-9_-]{1,40}$/.test(name);
}

/** The param name a link's beacon is written to. */
export function resolveUtmTermParam(link: Pick<VanityLink, "utmTermParam">): string {
  const custom = link.utmTermParam?.trim();
  return custom && isValidParamName(custom) ? custom : UTM_TERM_PARAM_DEFAULT;
}

/** Destination URL with UTMs; the beacon is host + path only, no scheme (e.g. l.example.com/slug). */
export function buildRedirectDestinationUrl(link: VanityLink, shortLinkHostPath: string): string {
  const rawUrl = /^https?:\/\//i.test(link.url) ? link.url : `https://${link.url}`;
  const dest = new URL(rawUrl);
  if (link.utmSource) dest.searchParams.set("utm_source", link.utmSource);
  if (link.utmMedium) dest.searchParams.set("utm_medium", link.utmMedium);
  if (link.utmCampaign) dest.searchParams.set("utm_campaign", link.utmCampaign);
  dest.searchParams.set(resolveUtmTermParam(link), shortLinkHostPath);
  if (link.utmContent) dest.searchParams.set("utm_content", link.utmContent);
  if (link.clickIdEnabled) dest.searchParams.set("clickid", crypto.randomUUID());
  return dest.toString();
}
